// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"ec9a411f","595":"b1304772"}[chunkId] + ".chunk.js";
};